import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { closePopover } from '../../actions/popover'
import PopoverLayout from './popover_layout'
import List from '../list'
import { isStaff } from '../../initial_state'

class BusinessOptionsPopover extends React.PureComponent {

  handleOnClosePopover = () => {
    this.props.onClosePopover()
  }

  render() {
    const { isXS, business } = this.props

    if (!isStaff) return <div />

    const listItems = [
      {
        icon: 'ellipsis',
        title: `Open admin for business`,
        href: `/admin/businesses/${business.get('id')}`,
        openInNewTab: true,
      },
    ]

    return (
      <PopoverLayout
        width={410}
        isXS={isXS}
        onClose={this.handleOnClosePopover}
      >
        <List
          scrollKey='business_options'
          items={listItems}
          size={isXS ? 'large' : 'small'}
        />
      </PopoverLayout>
    )
  }

}

const mapDispatchToProps = (dispatch) => ({
  onClosePopover:() => dispatch(closePopover()),
})

BusinessOptionsPopover.defaultProps = {
  tab: PropTypes.string.isRequired,
  onClosePopover: PropTypes.func.isRequired,
}

export default connect(null, mapDispatchToProps)(BusinessOptionsPopover)